// extracted by mini-css-extract-plugin
export default {"heading":"FederationLoadingPage_heading__4gDQ8","pagination":"FederationLoadingPage_pagination__+qG5O","headingContainer":"FederationLoadingPage_headingContainer__KMB1I"};